import React from 'react';
import FlashSaleItem from '../../components/slider/FlashSaleItem';
import BrandItem from '../../components/slider/BrandItem';
import TopBrandItem from '../../components/slider/TopBrandItem';

import addvertised from "../../assets/images/slider/s3.jpg";
import { NavLink, useNavigate } from 'react-router-dom';

import ctaImg from "../../assets/images/cta.png";
import FlashDropSlider from "../../components/slider/FlashDropSlider";
import { modelImagePath, brandImagePath } from '../../utils/constants';
import SliderSlick from 'react-slick';
import './buyMobile.css';
import { NextArrow, PrevArrow } from '../../components/custom-arrows/CustomArrows';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const topBrands = [
    { name: "Apple", img: "apple-iphone-16-pro.webp", 'slug': 'apple' },
    { name: "Samsung", img: "samsung-galaxy-z-fold5.webp", 'slug': 'samsung' },
    { name: "Xiaomi", img: "xiaomi-14.webp", 'slug': 'xiaomi' },
    { name: "OnePlus", img: "oneplus-13.webp", 'slug': 'oneplus' },
    // { name: "Oppo", img: "oppo.png" },
    // { name: "Vivo", img: "vivo.png" },
];
const flashDropData = [
    {
        stock: 20,
        title: "Flash Drop",
        name: "Moto G 35 5G",
        dropDate: "16 Nov | 12 pm",
        oldPrice: "₹15,499",
        newPrice: "₹6,499*",
        img: ctaImg,
        link: "/product/moto-g35"
    },
    {
        stock: 40,
        title: "Flash Drop",
        name: "iPhone 12",
        dropDate: "17 Nov | 12 pm",
        oldPrice: "₹45,499",
        newPrice: "₹36,499*",
        img: ctaImg,
        link: "/product/iphone-12"
    },
];

const flashItems = [
    {
        img: 'apple-iphone-16-pro.webp',
        title: 'iPhone 12',
        price: '₹42,999',
        originalPrice: '₹55,000',
        discount: '22% Off',
        slug: 'iphone-12'
    },
    {
        img: 'samsung-galaxy-z-fold5.webp',
        title: 'Samsung M13',
        price: '₹9,999',
        originalPrice: '₹12,499',
        discount: '20% Off',
        slug: 'samsung-m13'
    },
    {
        img: 'oneplus-13.webp',
        title: 'OnePlus Nord CE',
        price: '₹19,499',
        originalPrice: '₹24,000',
        discount: '18% Off',
        slug: 'oneplus-nord-ce'
    },
    {
        img: 'realme-14-pro-lite-5g.webp',
        title: 'Redmi Note 11',
        price: '₹11,499',
        originalPrice: '₹14,499',
        discount: '21% Off',
        slug: 'redmi-note-11'
    },
    {
        img: 'xiaomi-14.webp',
        title: 'Vivo Y16',
        price: '₹8,799',
        originalPrice: '₹10,999',
        discount: '20% Off',
        slug: 'vivo-y16'
    },
];

const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
        {
            breakpoint: 992,
            settings: { slidesToShow: 3 }
        },
        {
            breakpoint: 768,
            settings: { slidesToShow: 2 }
        },
        {
            breakpoint: 576,
            settings: { slidesToShow: 1 }
        }
    ]
};
const topBrandScroll = [
    { name: 'Apple', img: 'apple.webp', price: '₹13,899', slug: 'apple' },
    { name: 'Samsung', img: 'samsung.webp', price: '₹5,599', slug: 'samsung' },
    { name: 'OnePlus', img: 'oneplus.webp', price: '₹6,599', slug: 'oneplus' },
    { name: 'Nokia', img: 'nokia.webp', price: '₹3,599', slug: 'nokia' },
    { name: 'Motorola', img: 'motorola.webp', price: '₹6,199', slug: 'motorola' },
    { name: 'LG', img: 'lg.webp', price: '₹5,799', slug: 'lg' },
    { name: 'Realme', img: 'realme.webp', price: '₹5,499', slug: 'realme' },
    { name: 'Xiaomi', img: 'xiaomi.webp', price: '₹7,299', slug: 'xiaomi' },
    { name: 'Vivo', img: 'vivo.webp', price: '₹8,799', slug: 'vivo' },
    { name: 'Google', img: 'google.webp', price: '₹6,699', slug: 'google' },
];

const BuyMobile = () => {
    const navigate = useNavigate();

    const handleBrandRedirect = (slug) => {
        navigate(`/brands/${slug}`);
    };
    return (
        <>
            <div className='container'>
                {/* <Slider /> */}
                <FlashDropSlider items={flashDropData} />

            </div>
            {/* <div className="container-fluid p-0">
                <img
                    src={BannerImage}
                    alt="Main Banner"
                    className="img-fluid w-100"
                    style={{ objectFit: "cover", maxHeight: "400px" }}
                />
            </div> */}

            {/* Favourite Brands Section */}

            <section className="favourite-brands-section py-4">
                <div className="container">

                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="section-title-wrap">
                            <h4 className="section-title">Top Brands</h4>
                        </div>
                        <NavLink to="/brands" className="text-primary small">
                            View All
                        </NavLink>
                    </div>




                    <div className="brand-scroll d-flex overflow-auto px-2">
                        {topBrandScroll.map((brand, index) => (
                            <TopBrandItem
                                key={index}
                                brand={brand}
                                imagePath={brandImagePath}
                            />
                        ))}
                    </div>


                </div>
            </section>




            <section className="flash-sale-section py-4">
                <div className="container">
                    <img
                        src={addvertised}
                        alt="Advertise"
                        style={{ width: "100%", height: "280px", objectFit: "cover" }}
                        className="img-fluid"
                    />
                </div>
            </section>
            {/* <section className="buy-mobile-banner py-4">
                <div className="container">
                    <div className="banner-inner d-flex flex-column flex-md-row align-items-center justify-content-between p-3 p-md-4 rounded">

                        <div className="banner-text mb-3 mb-md-0">
                            <h5 className="fw-bold mb-1">Buy Your Next Mobile at the Best Price!</h5>
                            <p className="mb-0 small text-muted">Refurbished, Certified & 100% Quality Checked</p>
                        </div>

                        <NavLink
                            to="/mobiles"
                            className="btn custom-btn fw-semibold px-4 py-2 rounded-pill"
                        >
                            Shop Now
                        </NavLink>

                    </div>
                </div>
            </section> */}

            <section className="flash-sale-section py-4">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="section-title-wrap mb-3">
                            <h4 className="section-title"> Flash Sale</h4>
                        </div>
                        <NavLink to="/offers" className="text-primary small">View All</NavLink>
                    </div>

                    <SliderSlick {...sliderSettings}>
                        {flashItems.map((item, index) => (
                            <FlashSaleItem key={index} item={{ ...item, img: `${modelImagePath}${item.img}` }} />
                        ))}
                    </SliderSlick>
                </div>
            </section>



        </>
    );
};

export default BuyMobile;
